import axiosInstance from './axiosInstance';

export const getParticipantes = async () => {
  try {
    const response = await axiosInstance.get('/api/carrerasListado');
    return response.data; // { success, data: [...], total, ... }
  } catch (error) {
    // Puedes lanzar error personalizado o loguear
    console.error('Error al obtener participantes:', error);
    throw error; // o return { success: false, message: error.message }
  }
};

export const crearUsuario = async (datos) => {
  try {
    const response = await axiosInstance.post('/usuarios', datos);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const obtenerUsuario = async (id) => {
  try {
    const response = await axiosInstance.get(`/api/usuarios/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const actualizarUsuario = async (datos) => {
  try {
    const payload = {
      ...datos
    };

    const response = await axiosInstance.post(
      '/api/editar',
      payload
    );

    return response.data;
  } catch (error) {
    console.error("Error al actualizar:", error);
    throw error;
  }
};

export const agregarUsuario = async (datos) => {
  try {
    const payload = {
      ...datos
    };

    const response = await axiosInstance.post(
      '/api/inscribirse/admin',
      payload
    );

    return response.data;
  } catch (error) {
    console.error("Error al actualizar:", error);
    throw error;
  }
};

export const eliminarParticipante = async (id) => {
  try {
    const response = await axiosInstance.delete(`/api/eliminar/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const enviarEmail = async (id) => {
  try {
    const response = await axiosInstance.post(`/api/participantes/${id}/correo`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCarreras = async () => {
  try {
    const response = await axiosInstance.get('/api/carreras');
    return response.data; // { success, data: [...], total, ... }
  } catch (error) {
    // Puedes lanzar error personalizado o loguear
    console.error('Error al obtener las carreras:', error);
    throw error; // o return { success: false, message: error.message }
  }
};

export const getGraficas = async () => {
  try {
    const response = await axiosInstance.get('/api/graficas');
    return response.data; // { success, data: [...], total, ... }
  } catch (error) {
    // Puedes lanzar error personalizado o loguear
    console.error('Error al obtener las graficas:', error);
    throw error; // o return { success: false, message: error.message }
  }
};

export const setCarreras = async (datos) => {
   try {
    const response = await axiosInstance.post('/usuarios', datos);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const activarCarrera = async (id) => {
  try {
    const response = await axiosInstance.put('/api/carreras/activar', { id });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const obtenerCarrera = async (id) => {
  try {
    const response = await axiosInstance.get(`/api/carrera/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const actualizarCarrera = async (id, datos) => {
  try {
    const response = await axiosInstance.put(`/api/actualizarcarrera/${id}`, datos);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const agregarCarreras = async (datos) => {
   try {
    const response = await axiosInstance.post('/api/agregarCarrera', datos);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const eliminarCarrera = async (id) => {
  try {
    const response = await axiosInstance.delete(`/api/eliminarcarrera/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
